const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export type AppInfo = {
  name: string;
  version: string;
  environment: string;
};

export async function getAppInfo(): Promise<AppInfo | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/app/version`);
    if (!response.ok) return null;
    const data = (await response.json()) as Partial<AppInfo>;
    if (!data.version) return null;

    return {
      name: data.name ?? 'mentara-backend',
      version: data.version,
      environment: data.environment ?? 'default',
    };
  } catch {
    return null;
  }
}

export const appApi = { getInfo: getAppInfo };
